<template>
  <div></div>
</template>

<script>
import GenericAction from './GenericAction';
import { eventBus } from '@/lib/events';

export default {
  name: 'ActionPrioritize',
  mixins: [GenericAction],
  methods: {
    selected() {
      this.selectedParticipants.forEach((part) => {
        this.prioritizeParticipant(part.identity);
      });
    },

    prioritizeParticipant(identity) {
      const partInfo = {
        identity,
        order: this.maxOrder + 1,
        selected: false,
      };

      this.api.updateParticipantInfo(partInfo, { to: 'host' });
    },
  },

  mounted() {
    eventBus.on('prioritizeParticipant', this.prioritizeParticipant);
  },
};
</script>
